let bgId = null;
let bgPlaying = null;
let voPlaying = null;

const Audio = {
    
    'playBackground': function(background, repeats = -1) // Loop forever by default
    {
        if(bgId && bgId == background)
        {
            // Do nothing, already playing
            return;
        }

        this.stopBackground();

        // Play it
        bgId = background;
        bgPlaying = createjs.Sound.play('backgrounds-' + background, { 'loop': repeats, 'volume': 0.1 } );

        return bgPlaying;
    },

    'stopBackground': function()
    {
        $rootScope.showAudio = false;

        if(bgPlaying)
        {
            bgPlaying.stop();
            bgPlaying = null;
            bgId = null;
        }
    },

    'muteBackground': function(mute)
    {
        createjs.Sound.muted = mute;
    },

    'playVoiceover': function(voiceover)
    {
        this.stopVoiceover();

        // Play it
        voPlaying = createjs.Sound.play(voiceover);
        return voPlaying;
    },

    'stopVoiceover': function()
    {
        if(voPlaying)
        {
            voPlaying.stop();
            voPlaying = null;
        }
    },

    'playSFX': function(sfx)
    {
        // Just blindly play it
        return createjs.Sound.play('sfx-' + sfx, { 'volume': 0.7 } );
    }
};

export default Audio;